var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('van-image',{staticClass:"empty-icon",attrs:{"src":require('@/assets/img/common/wujieguo.png')}}),_c('div',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }